import { atom } from "recoil";

// KP全医療機関マスタの投稿一覧用
export const postState = atom({
  key: "postState",
  default: {
    id: null,
    content: '',
    hospital_id: '',
    hospital_name: '',
    staff_users_id: '',
    staff_name: '',
    created_at: '',
  },
});